import env from '@config/env';
import {
  bindMerchantNavigate,
  consumePushNotificationFromUrl,
  flushPendingMerchantPushNotification,
  openMerchantPushNotification,
  unbindMerchantNavigate,
} from '@services/merchantNavigation';
import { selectBusinessesHydrated } from '@redux/merchant/merchantSlice';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const PUSH_MESSAGE_TYPES = new Set([
  'MERCHANT_PUSH_NOTIFICATION',
  'merchant-push-notification',
  'NOTIFICATION_OPEN',
]);

const MerchantNavigationBinder = () => {
  const navigate = useNavigate();
  const businessesHydrated = useSelector(selectBusinessesHydrated);

  useEffect(() => {
    if (env.APP_TYPE !== 'merchant') return undefined;

    bindMerchantNavigate(navigate);

    const urlPayload = consumePushNotificationFromUrl();
    if (urlPayload) {
      openMerchantPushNotification(urlPayload);
    }

    const handleWindowMessage = (event) => {
      const data = event?.data;
      if (!data || typeof data !== 'object') return;

      const type = String(data.type || data.event || '').trim();
      if (!PUSH_MESSAGE_TYPES.has(type)) return;

      openMerchantPushNotification(data.payload || data.notification || data.data || data);
    };

    window.addEventListener('message', handleWindowMessage);
    window.__dineSavvyOpenNotification = openMerchantPushNotification;

    return () => {
      window.removeEventListener('message', handleWindowMessage);
      if (window.__dineSavvyOpenNotification === openMerchantPushNotification) {
        delete window.__dineSavvyOpenNotification;
      }
      unbindMerchantNavigate();
    };
  }, [navigate]);

  useEffect(() => {
    if (env.APP_TYPE !== 'merchant' || !businessesHydrated) return;
    flushPendingMerchantPushNotification();
  }, [businessesHydrated]);

  return null;
};

export default MerchantNavigationBinder;
